import React from "react";
import StatsImg from "../../assets/Images/WebsiteStats.png";

import PhoneImg from "../../assets/Images/3Phones.png";

import { LearnMoreBtn } from "../LearnMoreBtn/LearnMoreBtn";

export function StatsSection(props) {
  return (
    <section className="statsBackground">
      <div className="statsSection">
        <div className="statsSectionInfoContainer">
          <h3 className="mediumHeadline">End Preventable Accidents</h3>
          <p className="bodyText">
            Workplace accidents are not inevitable. Each year, countless
            injuries occur that could have been avoided. Our safety software
            gives you the tools to take control, reduce risks, and create a
            truly safe environment. Don't leave safety to chance—empower your
            team to prevent accidents before they happen. Complete inspections
            on any device, any where!
          </p>
          <LearnMoreBtn />
        </div>
        <div className="statsSectionImgContainer">
          <img src={PhoneImg} alt="Collage" className="statsImg" />
        </div>
      </div>
    </section>
  );
}
